<template>
  <VLayout class="rounded rounded-md viewport-height-adjusted">
    <TheSidebar />

    <TheHeader />

    <VMain class="bg-background h-100 w-100" scrollable>
      <section class="ma-5">
        <slot />
      </section>
    </VMain>

    <CustomToast v-if="toastStore.messages.length > 0" />
  </VLayout>
</template>

<script setup lang="ts">
import { VLayout, VMain } from 'vuetify/components'
import CustomToast from '../components/shared/CustomToast/CustomToast.vue'
import { useToastStore } from '../store'
import TheSidebar from '@/modules/Core/components/layout/TheSidebar/TheSidebar.vue'
import TheHeader from '@/modules/Core/components/layout/TheHeader/TheHeader.vue'

defineOptions({
  name: 'TheDefaultLayout',
})

const toastStore = useToastStore()
</script>
